import React from 'react';
import {connect} from "react-redux";
import RaisedButton from 'material-ui/RaisedButton';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import AuthService from "../../../../services/AuthService";
import {getEntrepriseSalaries} from './../../../../actions/entreprise/actions_entreprise_1';




class ExcelUploadBtn extends React.Component {

    constructor(props){
        super(props);
        this.Auth =  new AuthService();
        this.handleExcelUpload = this.handleExcelUpload.bind(this);
    }

    handleExcelUpload(e){
        let formData = new FormData();
        console.log('toto',e);
        let imagefile = document.querySelector('#fileToUpload');
        formData.append("fileToUpload", imagefile.files[0]);
        this.Auth.fetch('/services/upload/excel/salaries', {}, formData)
            .then(resp=>{
                window.alert(resp.data.payload);
                this.props.dispatch(getEntrepriseSalaries());
            }).catch(err=> window.alert(err.response.data.payload))
    }



    render() {
        return (
            <RaisedButton
                label="Déposer le modèle rempli"
                labelPosition="before"
                style={{margin: 12, cursor:'pointer'}}
                containerElement="label"
                icon={<FileUploadIcon />}
            >
                <input
                    type="file"
                    accept=".xls"
                    onChange={this.handleExcelUpload}
                    onClick={e=>{e.target.value = null;}}
                    required="required"
                    name="fileToUpload"
                    id="fileToUpload"
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        width: '100%',
                        opacity: 0
                    }}
                />
            </RaisedButton>
        );
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(ExcelUploadBtn);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/ExcelUploadBtn.js